import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminGuard } from '../shared/guards/admin.guard';
import { AuthGuard } from '../shared/guards/auth.guard';
import { MainComponent } from './main.component';

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: 'essential',
        loadChildren: () => import('../main/01-essential/essential.module').then((m) => m.EssentialModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'tiss',
        loadChildren: () => import('../main/04-tiss/tiss.module').then((m) => m.TissModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'financial',
        loadChildren: () => import('../main/02-financial/financial.module').then((m) => m.FinancialModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'invoicing',
        loadChildren: () => import('../main/03-invoicing/invoicing.module').then((m) => m.InvoicingModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'admin',
        loadChildren: () => import('../main/05-admin/admin.module').then((m) => m.AdminModule),
        canActivate: [AuthGuard, AdminGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainRoutingModule {}
